import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useConfirmationPageNavigationExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.ConfirmationPageNavigation,
        AmplitudeVariants.ConfirmationPageNavigation.EasyNavigationDesign
    );
